import { toYouTubeEmbedUrl } from '../../utils/video.utils';

/**
 * Renders a responsive YouTube embed iframe.
 *
 * Accepts any standard YouTube URL format; URL normalisation is handled by
 * the shared `toYouTubeEmbedUrl` utility so the logic lives in one place.
 *
 * Returns null for unrecognised or empty URLs so callers can conditionally render.
 */

interface Props {
  url: string;
  title?: string;
}

export default function VideoEmbed({ url, title = 'Video' }: Props) {
  const embedUrl = toYouTubeEmbedUrl(url);
  if (!embedUrl) return null;

  return (
    <div className="mb-8">
      {/* 16:9 responsive wrapper */}
      <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
        <iframe
          className="absolute inset-0 w-full h-full rounded-lg"
          src={embedUrl}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
}
